/** @jsx jsx */
import { jsx, Box, Container, Flex } from 'theme-ui';
/* eslint-disable react/no-danger */
import React from 'react';
import BackgroundImage from 'gatsby-background-image';

// Node Types
import { SectionComponent } from '@codersclan/gatsby-theme-airfleet/src/@types';

// Node Components
import FluidImage from '@codersclan/gatsby-theme-airfleet/src/components/fluidImage';

// Types
import { CTA } from '../../@types/cta';
import { Section } from '../../@codersclan/gatsby-theme-airfleet/@types/section';

// Components
import CTAButton from '../../components/ctaButton';
import Text, { TEXT_TYPES } from '../../components/text';

// Styles
import { baseStyle } from './style';

interface HeroProps extends Section {
  title: {
    title: string;
  };
  text: {
    content: string;
  };
  cta: CTA;
  image?: {
    image: ImageType;
  };
  backgroundImage?: {
    image: ImageType;
  };
}

const Hero: SectionComponent<HeroProps> = React.memo(
  ({ title, text, cta, image, backgroundImage }) => {
    const heroContent = (
      <Container sx={baseStyle.mainContainer}>
        <Flex sx={baseStyle.mainRowContainer}>
          <Box sx={baseStyle.mainRowContainerBoxLeft}>
            {title && title.title && (
              <Text type={TEXT_TYPES.H1_BOLD} sx={baseStyle.title} lines="3">
                {title.title}
              </Text>
            )}
            {text && text.content && (
              <Text type={TEXT_TYPES.BODY_INTRO} sx={baseStyle.intro} lines="6">
                <span dangerouslySetInnerHTML={{ __html: text.content }} />
              </Text>
            )}
            <CTAButton type="link" cta={cta} sx={baseStyle.cta}>
              {cta.label}
            </CTAButton>
          </Box>
          {image && image?.image && (
            <Box sx={baseStyle.mainRowContainerBoxRight}>
              {image?.image && <FluidImage {...image?.image} title="" />}
            </Box>
          )}
        </Flex>
      </Container>
    );
    if (backgroundImage?.image?.localFile?.childImageSharp?.fluid) {
      return (
        <BackgroundImage
          fluid={backgroundImage?.image?.localFile?.childImageSharp?.fluid}
          sx={baseStyle.backgroundImage}
        >
          {heroContent}
        </BackgroundImage>
      );
    }
    return heroContent;
  },
);

export default Hero;
